export default __webpack_public_path__ + "images/QY.27b6cba.png";